import script from "./AddDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__